import { priceRanges, hotelTypes } from "../constants";

interface FilterPanelProps {
  priceRange: number;
  selectedStars: number[];
  onPriceChange: (index: number) => void;
  onStarToggle: (starValue: number) => void;
}

export default function FilterPanel({
  priceRange,
  selectedStars,
  onPriceChange,
  onStarToggle,
}: FilterPanelProps) {
  return (
    <div className="px-4 pb-4 pt-3 border-t border-gray-100" style={{ background: "#FAFBFC" }}>
      <div className="mb-3">
        <div className="text-xs font-semibold text-gray-500 mb-2">价格区间</div>
        <div className="flex flex-wrap gap-2">
          {priceRanges.map((p, i) => (
            <button
              key={p}
              onClick={() => onPriceChange(i)}
              className="px-3 py-1.5 rounded-full text-xs cursor-pointer whitespace-nowrap transition-all"
              style={{
                background: priceRange === i ? "#1E3A8A" : "#F3F4F6",
                color: priceRange === i ? "#fff" : "#6B7280",
              }}
            >
              {p}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div className="text-xs font-semibold text-gray-500 mb-2">酒店星级（可多选）</div>
        <div className="flex flex-wrap gap-2">
          {hotelTypes.map((label, i) => {
            const starValue = i + 1; // value: 1~5
            const isSelected = selectedStars.includes(starValue);
            return (
              <button
                key={starValue}
                onClick={() => onStarToggle(starValue)}
                className="px-3 py-1.5 rounded-full text-xs cursor-pointer whitespace-nowrap transition-all"
                style={{
                  background: isSelected ? "#1E3A8A" : "#F3F4F6",
                  color: isSelected ? "#fff" : "#6B7280",
                }}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
